import axios from 'axios';
import api from '../../../config/services';
import Act from '../../../store/actions';

// 取得 publication relation data
export const getPubRelationData = (dispatch) => {
	axios
		.get(api.getSNAData)
		.then((result) => {
			// 讀取 region
			const regionList = [];
			// 讀取 country
			const countryList = [];
			const regionKey = ['srcLocRegion', 'dstLocRegion'];
			const countryKey = ['srcLocCountry', 'dstLocCountry'];
			if (Array.isArray(result.data.data)) {
				const { data } = result.data;
				data.forEach((dt) => {
					regionKey.forEach((rk) => {
						if (rk in dt && dt[rk] && !regionList.includes(dt[rk])) {
							regionList.push(dt[rk]);
						}
					});
					countryKey.forEach((ck) => {
						if (ck in dt && dt[ck] && !countryList.includes(dt[ck])) {
							countryList.push(dt[ck]);
						}
					});
				});
				dispatch({
					type: Act.SNA_REGION_LIST,
					payload: regionList,
				});
				dispatch({
					type: Act.SNA_COUNTRY_LIST,
					payload: countryList,
				});
				dispatch({
					type: Act.SNA_DB_DATA,
					payload: {
						initial: data,
						filter: data,
					},
				});
			} else {
				dispatch({
					type: Act.SNA_DB_DATA,
					payload: {
						initial: [],
						filter: [],
					},
				});
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

export const getPubData = ({ pubId, dispatch, initialData, setPubInfoLoading }) => {
	const url = api.getPublicationCardInfo.replace('{pubId}', pubId);
	axios
		.get(url)
		.then((result) => {
			// res.data.data[0]
			// {
			// 	authorEn: "Mir GhulāmʿAli Āzād Bilgrāmī"
			// 	authorFa: "میر غلام علی آزاد بلگرامی"
			// 	completionDate: "1666/1752-3"
			// 	locId: "LOC23"
			// 	location: "Awrangabad"
			// 	metaData: "S 1.2 p. 864; N pp. 383-90; G 1 pp. 706-7"
			// 	publicationEn: "Sarv-i Āzād"
			// 	publicationFa: "سرو آزاد"
			// 	startDate: "
			// }
			if (Array.isArray(result?.data?.data)) {
				// make key to lowercase
				const newData = Object.entries(result.data.data[0]).reduce((acc, [key, val]) => {
					acc[key.toLowerCase()] = val;
					return acc;
				}, {});
				dispatch({
					type: Act.SNA_CUR_PUB_DATA,
					payload: initialData ? { ...initialData, ...newData } : newData,
				});
			}
		})
		.catch((error) => {
			console.log(error);
		})
		.finally(() => {
			setPubInfoLoading(false);
		});
};
